import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { SettingService } from './../../services/setting.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { DatePipe } from '@angular/common';
import { EncrDecrService } from '../../services/encr-decr.service';

@Component({
  selector: 'app-s-add-customer',
  templateUrl: './s-add-customer.component.html',
  styleUrls: ['./s-add-customer.component.css'],
  providers: [DatePipe]
})

export class SAddCustomerComponent implements OnInit {
  user_id: any = '';
  token: any = '';
  APIKEY: any = '';
  buttonDisabled: boolean;
  model: any = {};

  factLanguage: any = {};
  arr: any[] = [];
  key_info: any = {};
  emailcheck: boolean = false;
  noticeOfAssignmentDoc: any;
  noticeDocCheck: any = '';
  maxDate: Date;

  customMaxDate = new Date(2018, 9, 15);
  submitForm: FormGroup;
  loaderMode = false;

  constructor(
    private _company: CompanyService,
    private _setting: SettingService,
    private _factLang: FactLanguageService,
    private _router: Router,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private EncrDecr: EncrDecrService,
    private formbuilder: FormBuilder,
  ) {
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 7);
  }

  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.token = localStorage.getItem('token');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.model = {
      APIKEY: this.APIKEY,
      user_id: this.user_id
    };
    this.key_info = {
      APIKEY: this.APIKEY,
      user_id: this.user_id
    };

    this.getfactLang();

    document.getElementById('save_click').style.visibility = 'hidden';

    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [this.user_id],
      company_id: [''],
      dynamicFields: this.formbuilder.array([]),
      advance_rate: ''
    });

    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      account_id: [0],
      is_primary_account: [true],
      account_name: [''],
      account_number: [''],
      description: [''],
      ach: [true],
      wire: [false],
    });
    this.dynamicFields.push(dynamicFieldForm);

  }

  accOnKey(event: any) {
    //this.model["email_per_invoice"]= event.target.value;
  }


  // this function hide by deepak on 25/08/2022 and added new function below
  // onFileChange(event) {
  //   this.noticeOfAssignmentDoc = event.target.files[0];
  // }

  onFileChange(event) {
    if (event.target.files[0].type == 'application/pdf') {
      this.noticeDocCheck = false;
      this.noticeOfAssignmentDoc = event.target.files[0];
    } else {
      //this.noticeDocCheck = true;
      this.noticeOfAssignmentDoc = '';
      $("#noaDoc").val('');
      alert('Please upload PDF file only');

    }
  }

  onSubmit(form) {
    this.loaderMode = true;

    //condition added by deepak on 25/08/2022 for check NOA file type
    // if(this.noticeDocCheck==true && this.noticeOfAssignmentDoc==''){
    //   this.loaderMode = false;
    //   this.toastr.error('Please upload PDF file only', 'Error');
    //   return false ;
    // }

    var encrypted_id = this.EncrDecr.set(localStorage.getItem('key'), this.model.password);
    this.model.password = encrypted_id;
    //this.model.password.notice_of_assignment_doc_path= this.noticeOfAssignmentDoc;

    const formData = new FormData();
    formData.append('APIKEY', this.APIKEY);
    formData.append('user_id', this.user_id);

    formData.append('companyName', this.model["companyName"]);
    formData.append('contactPerson', this.model["contactPerson"]);
    formData.append('phone', this.model["phone"]);
    formData.append('email', this.model["email"]);
    formData.append('password', encrypted_id);
    formData.append('accEmail', (this.model["accEmail"] == undefined) ? '' : this.model["accEmail"]);
    formData.append('ccEmail', (this.model["ccEmail"] == undefined) ? '' : this.model["ccEmail"]);
    formData.append('notification_email', (this.model["notification_email"] == undefined) ? '' : this.model["notification_email"]);
    formData.append('clientCode', this.model["clientCode"]);
    formData.append('custAddress1', this.model["custAddress1"]);
    formData.append('custAddress2', (this.model["custAddress2"] == undefined) ? '' : this.model["custAddress2"]);
    formData.append('id', this.model["id"]);
    formData.append('custCity', this.model["custCity"]);
    formData.append('custCountry', this.model["custCountry"]);
    formData.append('edit_factoring', this.model["edit_factoring"]);
    formData.append('email_per_invoice', this.model["email_per_invoice"]);
    formData.append('fact_address1', this.model["fact_address1"]);
    formData.append('fact_auth_person', this.model["fact_auth_person"]);
    formData.append('fact_city_state', this.model["fact_city_state"]);
    formData.append('fact_email', this.model["fact_email"]);
    formData.append('fact_phone', this.model["fact_phone"]);
    formData.append('fact_soa_email', this.model["fact_soa_email"]);
    formData.append('assigned_notice', this.model["assigned_notice"]);
    formData.append('finance_company', this.model["finance_company"]);
    formData.append('instructions', this.model["instructions"]);
    formData.append('soa_assignment', this.model["soa_assignment"]);
    formData.append('stamp_location', this.model["stamp_location"]);
    formData.append('custState', this.model["custState"]);
    formData.append('custZip', this.model["custZip"]);
    formData.append('notice_of_assignment_doc_path', this.noticeOfAssignmentDoc);

    /*formData.append('assign_fileupload', this.model["assign_fileupload"]);
    formData.append('assign_soa', this.model["assign_soa"]);
    
    formData.append('address_id', this.model["address_id"]);
    formData.append('mobile_reminder', this.model["mobile_reminder"]);
    formData.append('recurring', this.model["recurring"]);
    formData.append('reminder_day_after', this.model["reminder_day_after"]);
    formData.append('reminder_day_before', this.model["reminder_day_before"]);
    formData.append('expiration_date', ( this.model["expiration_date"]==undefined)?'':this.model["expiration_date"] );
    formData.append('high_alert_email', this.model["high_alert_email"]);
    formData.append('fact_id', this.model["fact_id"]);
    formData.append('delete_status', this.model["delete_status"]);
    formData.append('due_date', this.model["due_date"]);
    formData.append('owner_id', this.model["owner_id"]);
    formData.append('package_id', this.model["package_id"]);
    formData.append('c_id', this.model["c_id"]);
    formData.append('status', this.model["status"]);
    formData.append('modified_by', this.model["modified_by"]);
    formData.append('modified_at', this.model["modified_at"]);
    formData.append('created_at', this.model["created_at"]);
    formData.append('created_by', this.model["created_by"]);*/

    this._company.storeCmp(formData)
      .subscribe(
        res => {
          this.loaderMode = false;

          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
            this.submitForm.get('company_id').setValue(res.company_id);
            this.addAccount('yy');
            this._router.navigate(['super-admin/customer-list/active']);
          }
          else {
            this.toastr.error(res.message, 'Error');
          }
        },
      );
  }

  getfactLang() {
    const getFactlang = {
      user_id: this.user_id,
      api_token: this.token,
      APIKEY: this.APIKEY
    }
    this._factLang.getFactactLang(getFactlang)
      .subscribe(
        res => {
          this.model = res;
          this.model["APIKEY"] = this.APIKEY;
          this.model["user_id"] = this.user_id;
          this.model["stamp_location"] = 8;
        },
      );
  }


  check_email(email) {
    const data = {
      email: email,
      APIKEY: this.APIKEY
    }
    this.emailcheck = false;
    this._setting.checkEmailExit(data)
      .subscribe(
        res => {

          if (res.status) {
            this.model["email"] = '';
            this.emailcheck = true;

          } else {
            this.emailcheck = false;

          }
        },
        err => console.log(err)
      );
  }

  myForm = new FormGroup({
    myDateYMD: new FormControl(new Date()),
  });


  addLine(index = 0) {
    var j = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      if (element.is_primary_account == true) {
        console.log(element.is_primary_account + 'primary');
        j++;
      } else {
        j = j + j;
      }
    });

    if (j == 0) {
      const dynamicFieldForm = this.formbuilder.group({
        id: [0],
        account_id: [0],
        is_primary_account: [true],
        account_name: [''],
        account_number: [''],
        description: [''],
        ach: [true],
        wire: [false],
      });
      this.dynamicFields.push(dynamicFieldForm);
    }
    else {
      const dynamicFieldForm = this.formbuilder.group({
        id: [0],
        account_id: [0],
        is_primary_account: [false],
        account_name: [''],
        account_number: [''],
        description: [''],
        ach: [true],
        wire: [false],
      });
      this.dynamicFields.push(dynamicFieldForm);
    }
  }


  addAccount(status = 'Act') {
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.submitForm.get('user_id').setValue(this.user_id);

    this._company.addAccount(this.submitForm.getRawValue()).subscribe(
      (response) => {
        if (response && response['status'] == true) {
        }
      }, err => {
        console.log(err);
      });
  }

  uncheckall(index) {
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      if (i != index) {
        element.is_primary_account = false;
      }
      else if (i == index) {
        element.is_primary_account = true;
      }
      else {
        console.log('else');
      } i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }

  deleteRow(lessonIndex) {
    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {

      var sss = new Array();

      i = 0;
      var prime = 0;

      this.submitForm.value.dynamicFields.forEach(element => {

        if (i == lessonIndex) {
          if (element.is_primary_account == true) {
            prime = 1;
          }

        }
        if (i == lessonIndex) {
          element.is_primary_account = true;
          sss.push(i);

          // if (element.account_id != '') {
          //   const accdelete = {
          //     APIKEY: this.APIKEY,
          //     user_id: this.user_id,
          //     company_id: this.company_id,
          //     account_id: element.account_id,
          //   }

          //   this._company.deleteAccount(accdelete).subscribe(
          //     (response) => {

          //       if (response && response['status'] == true && response['data'] != '') {
          //         this.addAccount('yy');
          //        // this.getFolderDocument(this.folderid, 'document');

          //       }
          //     });
          // }

        }

        i++;
      });

      for (var i = sss.length - 1; i >= 0; i--) {

        this.dynamicFields.removeAt(sss[i]);
      }
      var i = 1;
      this.submitForm.value.dynamicFields.forEach(element => {
        if (element.is_primary_account == true) {
          i = 0;
          // console.log(element.is_primary_account + i);
        }
      });
      var j = 0;
      this.submitForm.value.dynamicFields.forEach(element => {
        if (j == 0 && i == 1) {
          element.is_primary_account = true;
          // console.log(element.is_primary_account + 'delete368');
          j++;
        }
      });
      this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    }
  }

  submit_form() {
    $("#save_click").click();
  }

  setonecheckbox(index, val) {
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {

      if (i == index) {
        if (val == 'ach') {
          element.wire = false;
          element.ach = true;
        } if (val == 'wire') {
          element.ach = false;
          element.wire = true;
        }

      }

      i++;

    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);

  }

  onlynumber(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode != 45 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  advance(value: any) {
    if (value > 100 || value < 0) {
      alert('advance rate should be greater than 0 and less than 100');
      this.submitForm.get('advance_rate').setValue('');
    }
    // else{
    // alert(value);
    //}
  }


}
